import styled from 'styled-components';

const StyledPopover = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.35);
  border-radius: ${(props): string => props.theme.borderRadius.normal};
  background-color: ${(props): string => props.theme.colors.pureWhite};
  border: 1px solid ${(props): string => props.theme.colors.iceGray};
  padding: ${(props): string => props.theme.spaces.md};

  opacity: 0;
  z-index: ${(props): number => props.theme.zIndexFloor.roof};
`;

export default StyledPopover;
